import { createSelector } from 'reselect';
import PlaySequence from '../PlaySequence';
const getPlayTimer = (state) => state?.playTimer;
const getDFVPlay = (state) => state?.config?.dfvPlay;
const EMPTY_OBJECT = Object.freeze({});
let PlaySequenceInstance = null;

export const getPlayTimerState = createSelector(
    [getPlayTimer, getDFVPlay],
    (playTimer, dfvPlay) => {
        if (!PlaySequenceInstance) {
            PlaySequenceInstance = new PlaySequence(dfvPlay);
        }

        const { adjust = EMPTY_OBJECT, standard = EMPTY_OBJECT } = PlaySequenceInstance.getTimer(playTimer) || EMPTY_OBJECT;

        return {
            standard: {
                timer: standard.timer,
                timerNum: standard.timerNum,
                delay: 0
            },
            adjust: {
                timer: adjust.timer,
                timerNum: adjust.timerNum,
                delay: adjust.delay
            }
        };
    }
);
